<template>
    <div class="pg-category">
        <ul class="tabs clearfix">
            <li :class="tabsActive == 0 ? 'active' : ''"><a href="javascript:;" @click.prevent="switchTabs(0)">产品中心</a></li>
            <li :class="tabsActive == 1 ? 'active' : ''"><a href="javascript:;" @click.prevent="switchTabs(1)">应用市场</a></li>
            <li :class="tabsActive == 2 ? 'active' : ''"><a href="javascript:;" @click.prevent="switchTabs(2)">配方指南</a></li>
        </ul>
        <div class="category-wrapper">
            <div class="category2" id="lv1Wrapper">
                <ul>
                    <li :class="asideActive == idx ? 'active' : ''" v-for="(item, idx) in category2" :key="item.id"
                        :data-id="item.name"><a href="javascript:;"
                            @click.prevent="switchAsideTab(idx, item)">{{ item.name }}</a></li>
                </ul>
            </div>
            <div class="category3">
                <dl class="clearfix">
                    <!-- <dt>溶剂</dt> -->
                    <dd v-for="(item, idx) in category3" :key="item.id + Math.random()">
                        <a href="javascript:;"
                            :class="{ right: category3[idx].children.length > 0, down: cate4IsShow == item.id }"
                            @click="showCate4(item, idx)">
                            {{ item.name }}
                        </a>
                        <ul v-show='cate4IsShow == item.id'>
                            <li v-for="cate4 in category4" :key="cate4.id"><a href="javascript:;"
                                    @click.prevent="goProductList(item.id, cate4.id, cate4.name)">{{ cate4.name }}</a>
                            </li>
                        </ul>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import config from '../../common/config';
    import { Loading } from 'element-ui';
    export default {
        name: 'category',
        data() {
            return {
                tabsActive: 0,
                asideActive: 0,
                category2: [],
                category3: [],
                category4: [],
                cate4IsShow: "",
                category: [],
                type: '',
            }
        },
        metaInfo: {
            meta: [
                { name: "keywords", content: "chemical raw material, chemical properties,properties,chemical brand,coatings, inks, plastic,adhesive,PE,PP,PVC,resin,pigments, additives,TDS,MSDS,SDS" },
                { name: "description", content: "Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc." }
            ],
        },
        mounted() {
            _hmt.push(['_trackPageview', `/${window.location.hash}`]);
            let type = this.$route.query.type || 0;
            this.tabsActive = type;

            let loadingInstance = Loading.service({ text: '加载中...', spinner: 'el-icon-loading', background: 'rgba(255, 255, 255, 0.7)' });
            axios.get(config.PHPHOST + 'api/web/index.php?r=classification/list').then(
                res => {
                    if (res.data.flag == 0) {
                        this.category = res.data.data;
                        if (this.category.length > 0 && this.category[type].value && this.category[type].value.length > 0) {
                            this.category2 = this.category[type].value;
                            this.category3 = this.category2[0].children;
                            loadingInstance.close();
                        }
                    }
                },
                err => {

                }
            )
        },
        methods: {
            switchTabs(m) {
                this.tabsActive = m;
                this.asideActive = 0;
                this.cate4IsShow = "";
                switch (m) {
                    case 0:
                        this.category2 = this.productCenter;

                        this.switchAsideTab(0)
                        break;
                    case 1:
                        this.category2 = this.applyMarket;
                        this.switchAsideTab(0)
                        break;
                    case 2:
                        this.category2 = this.formulaGuide;
                        this.switchAsideTab(0)
                        break;
                    default:
                        this.category2 = this.productCenter;
                        this.switchAsideTab(0)
                        break;
                }
            },
            switchAsideTab(m, data) {
                //console.log(data)

                if (data && data.children && data.children.length <= 0) {
                    //console.log('tiaozhuan',  this.tabsActive)

                    this.$router.push({ path: 'prolist', query: { fr: 1, cid1: data.id, catename: data.name, type: 1, category: this.tabsActive, } })
                    this.asideActive = m;
                } else {
                    this.asideActive = m;
                    this.category3 = this.category2[m].children;
                    this.cate4IsShow = "";
                }


            },
            showCate4(x, y) {
                //console.log(x)
                if (this.category3[y].children.length > 0) {
                    this.cate4IsShow = this.cate4IsShow == x.id ? "" : x.id;
                    this.category4 = this.category3[y].children
                } else {
                    this.$router.push({ path: 'prolist', query: { fr: 1, cid1: this.category2[this.asideActive].id, cid2: x.id, catename: x.name, type: 2, category: this.tabsActive, } })
                    this.cate4IsShow = "";
                }
            },
            goProductList(cate2Id, cate3Id, name) {
                this.$router.push({ path: 'prolist', query: { fr: 1, cid1: this.category2[this.asideActive].id, cid2: cate2Id, cid3: cate3Id, catename: name, type: 3, category: this.tabsActive, } })
            }
        },
        computed: {
            productCenter() {
                if (this.category.length > 0 && this.category[0].value && this.category[0].value.length > 0) {
                    return this.category[0].value
                }
            },
            applyMarket() {
                if (this.category.length > 0 && this.category[1].value && this.category[1].value.length > 0) {
                    return this.category[1].value
                }
            },
            formulaGuide() {
                if (this.category.length > 0 && this.category[2].value && this.category[2].value.length > 0) {
                    return this.category[2].value
                }
            }
        }
    }
</script>
<style lang='less'>

    .pg-category {
        height: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        h2 {
            font-size: 1.8rem;
            line-height: 2.6rem;
            padding-left: 1rem;
            border-bottom: .1rem solid #f3f3f3;
            padding-top: .5rem;
            padding-bottom: .5rem;

        }

        .tabs {
            display: flex;
            flex: none;
            height: 4rem;
            position: relative;

            li {
                flex: 1;
                line-height: 4rem;
                border-bottom: .1rem solid #f3f3f3;
                text-align: center;
                font-size: 1.4rem;
                padding-left: 1rem;
                padding-right: 1rem;

                a {
                    display: block;
                }

                &.active {
                    a {
                        color: #0994ff;
                        border-bottom: .2rem solid #0994ff;
                    }

                }
            }
        }

        .category-wrapper {
            flex: 1;
            display: flex;
            overflow: hidden;

            .category2 {
                background-color: #f3f4f5;
                width: 30%;
                flex: none;
                height: calc(100vh - 4rem);
                overflow-y: auto;

                li {
                    line-height: 3rem;
                    font-size: 1.3rem;
                    text-align: center;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;

                    a {
                        position: relative;
                        display: block;
                        padding-left: 5px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;

                        &::after {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 50%;
                            margin-left: -2.1rem;
                            width: 4.2rem;
                            height: .2rem;
                            border-bottom: .1rem solid #ddd;
                        }
                    }

                    &.active {
                        background-color: #fff;

                        a {
                            &::after {
                                content: '';
                                display: none;
                            }

                            &::before {
                                content: "";
                                position: absolute;
                                height: 2rem;
                                width: .3rem;
                                background-color: #0994ff;
                                left: 0;
                                top: .5rem;
                            }
                        }
                    }
                }
            }

            .category3 {
                width: 70%;
                height: calc(100vh - 4rem);
                overflow-y: scroll;

                dl {
                    padding-bottom: 1rem;
                    position: relative;

                    dt {
                        margin-top: 1rem;
                        line-height: 3rem;
                        padding-left: 1rem;
                        font-size: 1.6rem;
                        font-weight: 600;
                        color: #0994ff;
                    }

                    dd {
                        float: left;
                        padding: .5rem 1rem;
                        height: 30px;
                        box-sizing: border-box;
                        margin-bottom: .5rem;

                        a {
                            display: block;
                            position: relative;

                        }

                        .right {
                            &::after {
                                content: '';
                                position: absolute;
                                width: 1rem;
                                height: 1rem;
                                right: -1rem;
                                background: url(../../assets/images/arrow-r.png) center no-repeat;
                                background-size: contain;
                                margin-top: .2rem;
                                top: 0;
                            }
                        }

                        .down {
                            &::after {
                                content: '';
                                position: absolute;
                                width: 1rem;
                                height: 1rem;
                                right: -1rem;
                                background: url(../../assets/images/down-blue.png) center no-repeat;
                                background-size: contain;
                                margin-top: .2rem;
                            }
                        }

                        ul {
                            position: absolute;
                            width: 60vw;
                            left: 1rem;
                            margin-right: 1rem;
                            border: .1rem solid #ddd;
                            border-radius: .4rem;
                            background-color: #f3f3f3;
                            padding: 1rem;
                            box-sizing: border-box;
                            z-index: 9;

                            li {
                                margin-right: 1rem;
                                line-height: 2rem;
                                float: left;

                                a {
                                    color: #0994ff;
                                }
                            }
                        }
                    }
                }


            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/category.vue